export const config = {
  apiUrl: process.env.VITE_API_URL,
};
